import { render, staticRenderFns } from "./StudipMultiPersonSearch.vue?vue&type=template&id=0593eb45&"
import script from "./StudipMultiPersonSearch.vue?vue&type=script&lang=js&"
export * from "./StudipMultiPersonSearch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports